<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
          title="جزئیات وعده غذا"
        >
          <b-form
            ref="foodmealform"
            @submit.prevent
          >
            <b-row>
              <b-col
                class="mt-2"
                md="6"
                offset-md="3"
              >
                <b-row>

                  <b-col
                    cols="12"
                    class="mb-1"
                  >
                    <fm-file-select
                      v-model="Form.Image"
                      description="سایز تصویر می بایست کمتر از ۵ مگابایت باشد."
                      label="عکس"
                      :entity="1"
                    />
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="عنوان"
                      label-for="Title"
                    >
                      <b-form-input
                        id="Title"
                        v-model="Form.Title"
                        name="Title"
                        autocomplete="off"
                      />

                    </b-form-group>

                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="زمان شروع صرف غذا"
                      label-for="StartEatTime"
                    >
                      <z-form-timepicker
                          id="StartEatTime"
                          v-model="Form.StartEatTime"
                          name="StartEatTime"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="زمان پایان صرف غذا"
                      label-for="EndEatTime"
                    >
                      <z-form-timepicker
                        id="EndEatTime"
                        v-model="Form.EndEatTime"
                        name="EndEatTime"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="عنوان ویژه ماه رمضان"
                      label-for="RamezanTitle"
                    >

                      <b-form-input
                        id="RamezanTitle"
                        v-model="Form.RamezanTitle"
                        name="RamezanTitle"
                        autocomplete="off"
                      />

                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="زمان شروع صرف غذا در ماه رمضان"
                      label-for="RamezanStartEatTime"
                    >
                      <z-form-timepicker
                        id="RamezanStartEatTime"
                        v-model="Form.RamezanStartEatTime"
                        name="RamezanStartEatTime"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="زمان پایان صرف غذا در ماه رمضان"
                      label-for="RamezanEndEatTime"
                    >
                      <z-form-timepicker
                        id="RamezanEndEatTime"
                        v-model="Form.RamezanEndEatTime"
                        name="RamezanEndEatTime"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                      label="توضیحات"
                      label-for="Description"
                    >
                      <div class="form-label-group">
                        <b-form-input
                          id="Description"
                          v-model="Form.Description"
                          name="Description"
                          autocomplete="off"
                        />
                      </div>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group
                      label="توضیحات ویژه ماه مبارک رمضان"
                      label-for="RamezanDescription"
                    >
                      <div class="form-label-group">
                        <b-form-input
                          id="RamezanDescription"
                          v-model="Form.RamezanDescription"
                          name="RamezanDescription"
                          autocomplete="off"
                        />
                      </div>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group
                      label="توضیحات زمان رسیدن وعده"
                      label-for="TimeArriveMessage"
                    >
                      <div class="form-label-group">
                        <b-form-input
                          id="TimeArriveMessage"
                          v-model="Form.TimeArriveMessage"
                          name="TimeArriveMessage"
                          autocomplete="off"
                        />
                      </div>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group class="mt-1">
                      <b-form-checkbox
                          v-model="Form.JustFoodList"
                          value="true"
                          name="JustFoodList"
                          class="custom-control-primary"
                      >
                        در این وعده فقط لیست رژیم برای کاربر نمایش داده شود.
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group class="mt-1 mb-2">
                      <b-form-checkbox
                          v-model="Form.IsLock"
                          value="true"
                          name="IsLock"
                          class="custom-control-primary"
                      >
                        این وعده برای کاربران بدون رژیم قفل باشد.
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

import ZFormTimepicker from '@/tools/timePicker.vue'
import FmFileSelect from '@/views/menu/file-manager/components/fmFileSelect.vue'

export default {
  name: 'FoodMealDetails',
  components: {
    ZFormTimepicker,
    FmFileSelect,
  },
  data() {
    return {
      Form: {
        Id: null,
        Title: null,
        RamezanTitle: null,
        StartEatTime: null,
        EndEatTime: null,
        RamezanStartEatTime: null,
        RamezanEndEatTime: null,
        Description: null,
        RamezanDescription: null,
        Language: null,
        Image: null,
        JustFoodList: false,
        IsLock: false,
        TimeArriveMessage: '',
      },
      loading: false,
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    }
  },
  methods: {
    save() {
      let url = this.$api.foodmeal.add
      if (this.$route.params.id) {
        url = this.$api.foodmeal.update
      }

      this.loading = true
      this.$http.post(url, this.Form)
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.foodmeal.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data
        })
    },
  },
}
</script>
